import { Component, Input } from '@angular/core';
import { SpecialFormControl } from '@utilities/SpecialForms';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'control-select-multiple',
  templateUrl: './control-select-multiple.component.html',
  styleUrls: ['./control-select-multiple.component.scss']
})
export class ControlSelectMultipleComponent {
  @Input('readOnly') _readOnly = false;
  @Input('sfcontrol') _sfcontrol: SpecialFormControl;
  filterCtrl = new FormControl();
  value: any = "";
  subs: Subscription = new Subscription();
  data: Object[] = [];
  filteredData$: Observable<Object[]>;

  ngOnInit() {

    const dataControl$: Observable<{ RowKey: string, Name: string }[]> = this._sfcontrol.data[0]
      .pipe(
        map((d: Object[]) => {
          const master = this._sfcontrol.data[5];
          const slave = this._sfcontrol.data[6];
          if (slave) {
            return this.data = d.map(i => ({ RowKey: i['RowKey'], Name: `${i[master]}-${i[slave]}` }));
          } else {
            return this.data = d.map(i => ({ RowKey: i['RowKey'], Name: `${i[master]}` }));
          }
        }
        )
      )

    const filterWord$: Observable<string> = this.filterCtrl.valueChanges
      .pipe(
        startWith(''),
        //debounceTime(500),
        map((i: string) => i.toLowerCase()),
      );

    this.filteredData$ = combineLatest(dataControl$, filterWord$)
      .pipe(
        map(([a, b]) => {
          if (b.length === 0) {
            return a;
          } else {
            return a.filter(i => i.Name.toLowerCase().includes(b));
          }
        })
      );

  }

  select(value: string[]) {
    const complemento: string[] = [];
    complemento.push(this.data.find(object => object['RowKey'] === value)['Name']);
    const complementName = this._sfcontrol.data[7];
    this._sfcontrol.setComplement({ [complementName]: complemento.join('; ') });

    let val = { [complementName]: complemento.join('; ') }

    this._sfcontrol.setValue(value);
    this._sfcontrol.markAsDirty();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
